/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useContext, useEffect, useState } from 'react';
import { Button, DialogActions, DialogContent, Dialog, Grid, Tabs, Tab, DialogTitle, Stack, Typography, Box } from '@mui/material';
import MediaDriveUpload from './Components/MediaDrive';
import SystemUpload from './Components/System';
import CloseIcon from '@mui/icons-material/Close';
import { LanguageContext } from '../../../../../../libs/Context';
import ImageEditor from '../ImageEditor';
import { createFeedContext } from '../CreationPopup';
import { s3DeleteNew } from '../../../../../../libs/HelperContent';

const MediaDrivePopup = (props) =>
{
	const { open, handleClose, footerActn, requestT, externalFile, setOtherModuleFile, type } = props;
	const [ value, setValue ] = useState(0);
	const [ openImgFilters, setOpenImgFilters ] = useState(false);
	const { language } = useContext(LanguageContext);
	const { createFeed, setCreateFeed } = useContext(createFeedContext);

	const [ uploadedFiles, setUploadedFiles ] = useState<any>([]);

	const handleChange = (event, newValue) =>
	{
		setValue(newValue);
	};

	const updateMediaData = (data) =>
	{
		setCreateFeed((prev) => ({
			...prev,
			media : [ ...prev?.media ?? [], ...data ]
		}));
	};

	// footeraction containg image/video/application
	const handleMedia = () =>
	{
		// Determine media types based on new footerActn format
		const isImageVideoAction = footerActn === 'image_video';
		const isApplicationAction = footerActn === 'application';

		const filterData = uploadedFiles?.filter((mediaD) => [ 'video', 'application' ].includes(mediaD?.type?.split('/')[0]));

		const filterImgs = uploadedFiles?.filter((mediaD) =>
			mediaD?.type?.split('/')[0] === 'image'
		);

		// Add filtered media to createFeed
		if (filterData?.length > 0)
		{
			updateMediaData(filterData);
		}

		// Handle different action scenarios
		if (isImageVideoAction)
		{
			// For image_video action
			if (filterImgs?.length > 0)
			{
				setUploadedFiles([ ...filterImgs ]);
				setOpenImgFilters(true);
			}
			else
			{
				handleClose();
			}
		}
		else if (isApplicationAction)
		{
			// For application action
			if (filterImgs?.length > 0)
			{
				setCreateFeed((prev) => ({
					...prev,
					media : [ ...prev?.media ?? [], ...filterImgs ]
				}));
			}
			handleClose();
		}
	};
	// const handleMedia = () =>
	// {
	// 	const filterData = uploadedFiles?.filter((mediaD) => [ 'video', 'application' ].includes(mediaD?.type?.split('/')[0]));
	// 	const filterImgs = uploadedFiles?.filter((mediaD) => mediaD?.type?.split('/')[0] === 'image');

	// 	if (filterData?.length > 0)
	// 	{
	// 		// If video/Appilictn exists, add them to createFeed
	// 		updateMediaData(filterData);
	// 	}
	// 	if (footerActn === 'image')
	// 	{
	// 		filterImgs?.length > 0 ? (setUploadedFiles([ ...filterImgs ]), setOpenImgFilters(true)) : handleClose();
	// 	}
	// 	else if (footerActn === 'video' || footerActn === 'application')
	// 	{
	// 		if (filterImgs?.length > 0)
	// 		{
	// 			setCreateFeed((prev) => ({
	// 				...prev,
	// 				media : [ ...prev?.media ?? [], ...filterImgs ]
	// 			}));
	// 		}

	// 		handleClose();
	// 	}
	// 	// else
	// 	// {
	// 	// 	setCreateFeed((prev) => ({
	// 	// 		...prev,
	// 	// 		media : uploadedFiles
	// 	// 	}));
	// 	// 	handleClose();
	// 	// }
	// };

	const handleRemove = async () =>
	{
		if (createFeed?.media?.length > 0 || uploadedFiles?.length === 0)
		{
			handleClose();
		}
		else
		{
			await Promise.all(uploadedFiles?.map(async (mediaD) => await s3DeleteNew(mediaD?.key, '')));
			setUploadedFiles([]);
			handleClose();
		}
	};

	useEffect(() =>
	{
		if (requestT === 'driveUpload' &&
			externalFile?.length > 0 &&
			[ 'image' ].includes(externalFile?.[0]?.type?.split('/')?.[0]))
		{ // for directly opening the imageEditor component for file selected from media drive
			setUploadedFiles((prev) => ([ ...prev, ...externalFile ]));
			setOpenImgFilters(true);
		}

		return () =>
		{
			externalFile?.length > 0 && setOtherModuleFile([]);
		};
	}, [ externalFile ]);

	const handleCloseImageEditor = () =>
	{
		if (externalFile?.length > 0)
		{
			handleRemove();
		}
		setOpenImgFilters(false);
	};

	return (
		<Dialog
			open={open}
			onClose={handleRemove}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle>
				<Grid container display={'flex'} alignItems={'center'}>
					<Grid item xs>
						<Tabs
							value={value}
							onChange={handleChange}
							variant='scrollable'
							scrollButtons='auto'
							aria-label='scrollable auto tabs example'
						>
							<Tab
								iconPosition='start'
								label={language?.mediaDrive}
								value={0}
								sx={{ fontSize: 'var(--pixel16)' }}
							/>
							<Tab
								iconPosition='start'
								label={language?.system}
								value={1}
								sx={{ fontSize: 'var(--pixel16)' }}
							/>
						</Tabs>
					</Grid>
					<Grid item display={'flex'} alignItems={'center'} onClick={handleRemove}>
						<CloseIcon className='lightTxt pointer' />
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent sx={{ minHeight: '300px' }}>
				<Grid container >
					{value === 0 && (
						<MediaDriveUpload
							setUploadedFiles={setUploadedFiles}
							uploadedFiles={uploadedFiles}
							footerActn={footerActn}
						/>
					)}
					{value === 1 && (
						<SystemUpload
							// onImagesUploaded={setUploadedImageCount}
							setUploadedFiles={setUploadedFiles}
							uploadedFiles={uploadedFiles}
							footerActn={footerActn}
						/>
					)}
				</Grid>
			</DialogContent>
			<DialogActions sx={{ margin: '0 16px 16px 0' }}>
				<Stack direction='row' display={'flex'} justifyContent={'space-between'} width={'var(--percent100)'}>
					<Box>
						{value === 0 && <Typography pl='var(--pixel16)' variant='body2'> {language?.share} {footerActn === 'application' ? `${language?.documents}` : (footerActn === 'image_video' ? 'Image/Video' : footerActn)} {footerActn === 'application' ? `${language?.uploadLimitDoc}` : `${language?.cannotUploadMoreThan20Files}`}</Typography>}
					</Box>
					<Stack direction='row' spacing={2} justifyContent={'flex-end'} alignItems={'flex-end'}>
						<Button onClick={handleRemove} variant='outlined' size='small'>
							{language?.cancel}
						</Button>
						<Button
							onClick={handleMedia}
							variant='contained'
							sx={{ color: 'var(--whiteColor)' }}
							disabled={uploadedFiles.length === 0}
							// disabled={!isNextButtonEnabled}
							className={`${uploadedFiles.length === 0 ? 'disableBtnMode buttonBg' : 'buttonBg'}`}
							// Disable "Next" button if no images are selected/uploaded
							size='small'
						>
							{language?.next}
						</Button>
					</Stack>
				</Stack>
			</DialogActions>
			{openImgFilters && ( // for editing images only
				<ImageEditor
					open={openImgFilters}
					uploadedFiles={uploadedFiles}
					onClose={handleCloseImageEditor}
					setUploadedFiles={setUploadedFiles}
					handleCloseImgPop={() => { handleClose(); setOpenImgFilters(false); }}
				/>
			)}
		</Dialog>);
};

export default MediaDrivePopup;
